/* src/app/forms/json-component/config-json/config-json.component.scss */
.card-header {
  margin-top: 5px;
}
.headerRow {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 17px;
  margin-left: 14px;
}
.container-fluid {
  width: 100%;
  padding: 20px;
}
::ng-deep .full-screen-dialog .mat-dialog-container {
  padding: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  max-width: 100vw !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}
.mat-mdc-tab-body.mat-tab-body-active {
  height: 60vh;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: 100%;
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.toogleTest {
  margin-left: 14px;
  margin-top: 6px;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.my-button-class {
  height: 36px;
  line-height: 36px;
}
.margin-top10 {
  margin-top: 10px;
}
.align-items {
  align-items: center;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100% !important;
}
.button-margin {
  margin-right: 10px;
  margin-bottom: 5px;
}
.mat-toolbar {
  background: rgba(0, 0, 0, 0.03) !important;
}
.combined-tab .mat-tab-body-wrapper {
  display: flex;
}
.combined-tab .mat-tab-body-wrapper > div {
  flex: 1;
}
.mat-grid-tile {
  display: flex;
  justify-content: center;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.grid-container {
  flex: 1;
  display: flex;
}
.grid-item {
  flex: 1;
}
.view-component-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content-tab {
  flex: 1;
  display: flex;
  margin-top: 5px;
}
.simple-datagrid {
  flex: 1;
}
.separator {
  height: 1px;
  background-color: #ccc;
  margin: 10px 0;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.config-info {
  display: flex;
  align-items: center;
  font-size: 114%;
}
.config-label {
  font-weight: bold;
  margin-right: 5px;
}
.config-values {
  color: #333;
}
.config-separator {
  margin: 0 5px;
  color: #777;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=config-json.component.css.map */
